import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRICS]: {
		url:'/company/:companyId/regulations/:regulationId/metrics/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].GET_REGULATIONS_METRIC]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].CREATE_REGULATIONS_METRIC]: {
		url:'/company/:companyId/regulations/:regulationId/metrics/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PATCH_REGULATIONS_METRIC]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].PUT_REGULATIONS_METRIC]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_METRICS].DELETE_REGULATIONS_METRIC]: {
		url: '/company/:companyId/regulations/:regulationId/metrics/:metricId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}